export enum ContentBlockType {
  LegacyRichTextEditor = 'legacyrichtexteditor',
  RichTextEditor = 'richtexteditor',
  TextImage = 'textimage',
  Images = 'images',
  File = 'file',
  Speakers = 'speakers',
  Logos = 'logos',
  Accordion = 'accordion',
  MultiColumns = 'multicolumns',
  MultiRows = 'multirows',
  Banner = 'banner',
  Video = 'video',
}

export const isEnhancedContentBlockType = (type: ContentBlockType): boolean => {
  const basicContentBlocks = [
    ContentBlockType.RichTextEditor,
    ContentBlockType.LegacyRichTextEditor,
    ContentBlockType.Video,
  ];

  return !basicContentBlocks.includes(type);
};

export const isVideoContentBlockType = (type: ContentBlockType): boolean => {
  return type === ContentBlockType.Video;
};
